import { useTheme } from '@mui/material/styles';
import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

import { FormattedMessage } from 'react-intl';

import useAuth from 'hooks/useAuth';
import useConfig from 'hooks/useConfig';

import { IconBuilding } from '@tabler/icons-react';

export default function HotelSection() {
  const theme = useTheme();
  const {
    state: { borderRadius }
  } = useConfig();
  const { allowedHotels, selectedHotelId, setSelectedHotel } = useAuth();

  if (allowedHotels.length === 0) {
    return null;
  }

  const selectedHotel = allowedHotels.find((h) => h.id === selectedHotelId);
  const value = selectedHotelId ?? '';

  const handleChange = (event: { target: { value: unknown } }) => {
    const id = Number(event.target.value);
    if (id) setSelectedHotel(id);
  };

  return (
    <Box sx={{ ml: 1, minWidth: 180, display: { xs: 'none', sm: 'block' } }}>
      <FormControl size="small" fullWidth>
        <Select
          displayEmpty
          value={value}
          onChange={handleChange}
          renderValue={(v) => {
            if (!v)
              return (
                <Typography variant="body2" color="text.secondary">
                  <FormattedMessage id="header.hotel.placeholder" defaultMessage="Válassz hotelt" />
                </Typography>
              );
            const h = allowedHotels.find((x) => x.id === v);
            return (
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <IconBuilding size={18} stroke={1.5} style={{ color: theme.vars.palette.primary.main }} />
                <Typography variant="body2" noWrap>{h?.name ?? String(v)}</Typography>
              </Box>
            );
          }}
          sx={{
            borderRadius: `${borderRadius}px`,
            bgcolor: theme.vars.palette.background.paper,
            ...theme.applyStyles('dark', { bgcolor: 'dark.800' })
          }}
        >
          <MenuItem value="">
            <Typography variant="body2" color="text.secondary">
              <FormattedMessage id="header.hotel.placeholder" defaultMessage="Válassz hotelt" />
            </Typography>
          </MenuItem>
          {allowedHotels.map((h) => (
            <MenuItem key={h.id} value={h.id}>
              <Typography variant="body2">{h.name}</Typography>
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
}
